module.exports = __webpack_public_path__ + "static/media/percent.93d4e063.svg";